const CHARACTER_IDS: number[] = []

export { CHARACTER_IDS }
